import { render, staticRenderFns } from "./IndexForm.vue?vue&type=template&id=611a01b0"
import script from "./IndexForm.vue?vue&type=script&lang=js"
export * from "./IndexForm.vue?vue&type=script&lang=js"
import style0 from "./IndexForm.vue?vue&type=style&index=0&id=611a01b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports